import React, { useState, useMemo, useRef, useEffect } from "react";


// const PropertyList = ({ parcels = [] }) => {
const PropertyList = ({
    parcels = [],
    onRowClick,
    selectedParcelId,
    setSelectedParcelId,
    sortKey: propSortKey,
    setSortKey: propSetSortKey,
    sortDir: propSortDir,
    setSortDir: propSetSortDir,
    currentZoom,
    loadMore,
    hasMore,
    isLoadingMore = false,
    rowOffset = 0,
    isAdjacentMode = false,
    selectionMode = false,
    // selectedRowIds = new Set(),
    selectedRowIds,
    toggleRowSelection,
    toggleSelectAll,
    isAllSelected = false,
    showDownloadButton = false,
    onExportCsv,
    onExportPdf,
    onSaveToFavorites,
    onRemoveFromFavorites,
    removeAllFavorites,
    showFavoritesOnly = false,
    favoriteParcelIds = [],
    onToggleFavorite,
}) => {
    const loadMoreTargetRef = useRef(null);
    const previousCountRef = useRef(parcels.length);
    const [showDeletePopup, setShowDeletePopup] = useState(false);
    // Removed: Last row highlight feature
    // const [lastLoadedIndex, setLastLoadedIndex] = useState(-1);

    // Track when new records are loaded - DISABLED
    // useEffect(() => {
    //     if (!isLoadingMore && parcels.length > previousCountRef.current) {
    //         // Mark the last index of the previous batch
    //         setLastLoadedIndex(previousCountRef.current - 1);

    //         // Clear the highlight after 3 seconds
    //         setTimeout(() => {
    //             setLastLoadedIndex(-1);
    //         }, 3000);
    //     }
    //     previousCountRef.current = parcels.length;
    // }, [parcels.length, isLoadingMore]);

    // Infinite scroll: Auto-load when scrolling near bottom
    useEffect(() => {
        if (!loadMoreTargetRef.current || !hasMore || isLoadingMore) return;

        const observer = new IntersectionObserver(
            (entries) => {
                // When the target element becomes visible, load more
                if (entries[0].isIntersecting && hasMore && !isLoadingMore) {
                    console.log('Infinite scroll triggered - loading more...');
                    loadMore();
                }
            },
            {
                root: null, // viewport
                rootMargin: '200px', // Trigger 200px before reaching the element
                threshold: 0.1
            }
        );

        observer.observe(loadMoreTargetRef.current);

        return () => {
            if (loadMoreTargetRef.current) {
                observer.unobserve(loadMoreTargetRef.current);
            }
        };
    }, [hasMore, isLoadingMore, loadMore]);

    // Auto-scroll to newly loaded content
    // useEffect(() => {
    //     if (!isLoadingMore && parcels.length > previousCountRef.current && loadMoreTargetRef.current) {
    //         // Scroll to the newly loaded section
    //         setTimeout(() => {
    //             loadMoreTargetRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    //         }, 100);
    //     }
    //     previousCountRef.current = parcels.length;
    // }, [parcels.length, isLoadingMore]);

    // Use local state for client-side sorting
    // Use parent props for API sorting
    const [localSortKey, setLocalSortKey] = useState('spreadpercentage');
    const [localSortDir, setLocalSortDir] = useState('desc');

    // Use API sorting if parent is controlling sort (provides setSortKey callback)
    const useApiSorting = propSetSortKey !== undefined && propSetSortKey !== null;
    const sortKey = useApiSorting && propSortKey !== undefined ? propSortKey : localSortKey;
    const setSortKey = useApiSorting && propSetSortKey ? propSetSortKey : setLocalSortKey;
    const sortDir = useApiSorting && propSortDir !== undefined ? propSortDir : localSortDir;
    const setSortDir = useApiSorting && propSetSortDir ? propSetSortDir : setLocalSortDir;
    // state
    const [isSelectMode, setIsSelectMode] = useState(false);

    const toggleSort = (key) => {
        if (sortKey === key) {
            setSortDir((d) => (d === "asc" ? "desc" : "asc"));
        } else {
            setSortKey(key);
            setSortDir("asc");
        }
    };

    const parseNumber = (v) => {
        if (v === null || v === undefined) return NaN;
        const n = Number(String(v).replace(/[^0-9.-]/g, ""));
        return Number.isFinite(n) ? n : NaN;
    };

    const normalizeParcelIdentifier = (parcelId) => {
        return parcelId == null ? "" : String(parcelId).trim().toLowerCase();
    };

    // Normalize incoming parcels (if GeoJSON features, use .properties)
    const normalizedItems = useMemo(() => {
        if (!Array.isArray(parcels)) return [];
        return parcels.map((it) => {
            if (!it) return {};
            if (it.properties && typeof it.properties === "object") return { ...it.properties, __feature__: it };
            return { ...it };
        });
    }, [parcels]);

    // Sorting implementation that pushes non-numeric values to the end
    const sortedParcels = useMemo(() => {
        if (!normalizedItems || normalizedItems.length === 0) return [];
        if (!sortKey) return normalizedItems;

        // const getKeyVal = (item) => {
        //     if (sortKey === "totalunits") {
        //         return parseNumber(item.totalunits ?? item.total_units ?? item.units ?? item.Unit);
        //     }
        //     if (sortKey === "totallandvalue") {
        //         return parseNumber(
        //             item.totallandvalue ??
        //             item.total_land_value ??
        //             item.totallandvalue_usd ??
        //             item.totallandvalue ??
        //             item.landvalue ??
        //             item.land_value ??
        //             item.totalvalue ??
        //             item.total_value
        //         );
        //     }
        //     // NEW: Spread % sorting
        //     if (sortKey === "spreadpercentage") {
        //         return parseNumber(
        //             item.spreadpercentage ??
        //             item.spreadPercent ??
        //             item.spread_percentage ??
        //             item.spread_percent
        //         );
        //     }
        //     return NaN;
        // };

        const getKeyVal = (item) => {
            if (sortKey === "totalunits") {
                return parseNumber(item.totalunits ?? item.total_units ?? item.units ?? item.Unit);
            }

            if (sortKey === "totallandvalue") {
                return parseNumber(
                    item.totallandvalue ??
                    item.total_land_value ??
                    item.totallandvalue_usd ??
                    item.landvalue ??
                    item.land_value ??
                    item.totalvalue ??
                    item.total_value
                );
            }

            //  PRICE Zestimate
            if (sortKey === "zestimate") {
                return parseNumber(
                    item.zestimate ??
                    item.price ??
                    item.saleprice ??
                    item.sale_price
                );
            }

            //  SIZE Parcel size
            if (sortKey === "parcelsize") {
                return parseNumber(
                    item.parcelsize ??
                    item.parcel_size ??
                    item.landsize ??
                    item.land_size
                );
            }

            // Spread %
            if (sortKey === "spreadpercentage") {
                return parseNumber(
                    item.spreadpercentage ??
                    item.spreadPercent ??
                    item.spread_percentage ??
                    item.spread_percent
                );
            }

            // Zoning (string sorting)
            if (sortKey === "zoning") {
                return item.zoning ?? item.zonedcodelocal ?? item.zone ?? "";
            }

            return NaN;
        };


        const cmp = (a, b) => {
            const na = getKeyVal(a);
            const nb = getKeyVal(b);
            const aValid = Number.isFinite(na) || (typeof na === 'string' && na.trim() !== '');
            const bValid = Number.isFinite(nb) || (typeof nb === 'string' && nb.trim() !== '');
            if (!aValid && !bValid) return 0;
            if (!aValid) return 1; // push invalid to end
            if (!bValid) return -1;
            if (typeof na === 'string' && typeof nb === 'string') {
                return na.localeCompare(nb);
            }
            return na < nb ? -1 : na > nb ? 1 : 0;
        };

        // IMPORTANT: Don't re-sort if using API sorting (pagination)
        // The API already sorted the data, re-sorting changes row positions
        if (useApiSorting) {
            return normalizedItems; // Preserve API sort order
        }

        const arr = [...normalizedItems].sort((a, b) => {
            const r = cmp(a, b);
            return sortDir === "asc" ? r : -r;
        });
        return arr;
    }, [normalizedItems, sortKey, sortDir, useApiSorting]);

    const handleRowClick = (item, index) => {
        // if (  selectionMode ) {
        //     // toggleRowSelection(item);
        //     return; // Don't trigger onRowClick when toggling selection
        // }
        // Use parcel ID instead of index for selection
        const parcelId = item.parcel || item.parcelid || item.geo_id || item.id;

        // Only set selection if setSelectedParcelId is provided
        if (setSelectedParcelId) {
            setSelectedParcelId(parcelId); // Highlight selected row by ID
        }

        console.log("Row clicked:", item); // ✅ ADD: Debug log
        console.log("Coordinates:", item.latitude, item.longitude); // ✅ ADD: Check coords

        if (onRowClick && typeof onRowClick === "function") {
            // Pass the full property object to parent
            onRowClick(item);
        } else {
            console.warn("onRowClick is not a function or not provided"); // ✅ ADD: Warning
        }
    };

//     const handleRemoveFavorites = () => {
//     const confirmDelete = window.confirm(
//         "Delete selected parcels?"
//     );

//     if (confirmDelete) {
//         onRemoveFromFavorites();
//     }
// };const [showDeletePopup, setShowDeletePopup] = useState(false);

const handleRemoveFavorites = () => {
    setShowDeletePopup(true);
};

const confirmRemoveFavorites = () => {
    setShowDeletePopup(false);

    if (typeof onRemoveFromFavorites === "function") {
        onRemoveFromFavorites();
    }
};

const closeDeletePopup = () => {
    setShowDeletePopup(false);
};



   const handleRemoveAllFavorites = () => {
    const confirmDelete = window.confirm(
        "Delete selected parcels?"
    );

    if (confirmDelete) {
        onRemoveFromFavorites();
    }
};

    return (
        <div
            className="listOuter"
            style={{
                width: "100%",
                height: "100%",
                overflow: "auto",
            }}
        >
            <div
                style={{
                    display: "flex",
                    flexDirection: "column",
                }}
            >
                {/* Header */}
                <div style={{ flex: 1 }}  >
                    {parcels.length === 0 ? (
                        <div style={{ padding: "10px", textAlign: "center", color: "#777" }}>
                            No Records Found
                        </div>
                    ) : (
                        <>
                            <style>{`
                                @keyframes slideIn {
                                    from {
                                        opacity: 0;
                                        transform: translateY(-10px);
                                    }
                                    to {
                                        opacity: 1;
                                        transform: translateY(0);
                                    }
                                }
                            `}</style>
                            <table
                                className="property-table"
                                style={{
                                    //tableLayout: "auto", // let columns size naturally
                                    tableLayout: "fixed",
                                    minWidth: "1200px",
                                    width: "100%", // ensure table can overflow to show horizontal scroll
                                    borderCollapse: "collapse",
                                }}
                            >
                                <thead>
                                    <tr
                                        style={{
                                            background: "#e0e0e0",
                                            fontWeight: "bold",
                                            borderBottom: "1px solid #ccc",
                                        }}
                                    >
                                        {/* <th style={{ textAlign: "center", padding: "8px", width: "50px" }}>
                                            {selectionMode && !isAdjacentMode ? (
                                                <input
                                                    type="checkbox"
                                                    checked={isAllSelected}
                                                    onChange={() => {
                                                        if (typeof toggleSelectAll === "function") {
                                                            toggleSelectAll();
                                                        }
                                                    }}
                                                    style={{ cursor: "pointer" }}
                                                />
                                            ) : (
                                                "#"
                                            )}
                                        </th> */}
                                                     <th style={{ textAlign: "center", padding: "8px", width: "50px" }}>
                                            {showFavoritesOnly && !isAdjacentMode ? (
                                                <input
                                                    type="checkbox"
                                                    checked={isAllSelected}
                                                    onChange={() => {
                                                        if (typeof toggleSelectAll === "function") {
                                                            toggleSelectAll();
                                                        }
                                                    }}
                                                    style={{ cursor: "pointer" }}
                                                />
                                            ) : (
                                                "#"
                                            )}
                                        </th>
                                        {/* {!isAdjacentMode && (
                                            <th style={{ textAlign: "center", padding: "8px", width: "50px" }}>Fav</th>
                                        )} */}

                                        {!isAdjacentMode && (
    <th
        style={{
            textAlign: "center",
            padding: "8px",
            width: "80px",
        }}
    >
            {!showFavoritesOnly ? (
            <>
        <div
            style={{
                display: "flex",
                // alignItems: "center",
                alignItems: "flex-start",
                // justifyContent: "center",
                justifyContent: "flex-start",
                gap: "6px",
            }}
        >
            {/* Toggle Icon */}
            <button
                onClick={() => setIsSelectMode(!isSelectMode)}
                style={{
                    border: "none",
                    background: "transparent",
                    cursor: "pointer",
                    padding: 0,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                }}
            >
                <img
                    src={
                        isSelectMode
                            ? "/assets/close.svg"
                            : "/assets/select_mode.svg"
                    }
                    alt="Select Mode"
                    style={{
                        width: "18px",
                        height: "18px",
                    }}
                />
            </button>

            {/* Show checkbox OR Fav text */}
            {isSelectMode ? (
                <input
                    type="checkbox"
                    checked={isAllSelected}
                    onChange={() => {
                        if (typeof toggleSelectAll === "function") {
                            toggleSelectAll();
                        }
                    }}
                    style={{ cursor: "pointer" }}
                />
            ) : (
                <span>Fav</span>
            )}
        </div>
              </>
        ):( <span>Fav</span>)}
    </th>
)}
                                        <th style={{ textAlign: "left", padding: "8px", ...(isAdjacentMode ? { width: "120px" } : {}) }}>{isAdjacentMode ? "Parcels" : "Parcel"}</th>
                                        <th style={{ textAlign: "center", padding: "8px" }}>Muni</th>
                                        {/* <th style={{ 
        textAlign: "left", 
        padding: "8px 12px", 
        whiteSpace: "nowrap",
        width: "auto",        
      }}>
        Parcel
      </th> */}

                                        {/* <th style={{ textAlign: "right", padding: "8px" }}>Size</th> */}
                                        <th
                                            style={{
                                                textAlign: "right",
                                                padding: "8px",
                                                cursor: "pointer",
                                                userSelect: "none",
                                            }}
                                            onClick={() => toggleSort("parcelsize")}
                                        >
                                            Size
                                            <span style={{ fontSize: 11 }}>
                                                {sortKey === "parcelsize" ? (sortDir === "asc" ? "▲" : "▼") : "↕"}
                                            </span>
                                        </th>


                                        <th
                                            style={{
                                                textAlign: "right",
                                                padding: "8px",
                                                cursor: "pointer",
                                                userSelect: "none",
                                            }}
                                            onClick={() => toggleSort("zoning")}
                                        >
                                            Zoning
                                            <span style={{ fontSize: 11 }}>
                                                {sortKey === "zoning" ? (sortDir === "asc" ? "▲" : "▼") : "↕"}
                                            </span>
                                        </th>

                                        {/* <th style={{ textAlign: "right", padding: "8px" }}>sqft Price</th> */}
                                        <th style={{ textAlign: "right", padding: "8px" }}>Target ARV</th>
                                        <th style={{ textAlign: "right", padding: "8px" }}>Land value/Unit</th>

                                        {isAdjacentMode && (
                                            <th style={{ textAlign: "center", padding: "8px" }}>Townhouses</th>
                                        )}

                                        <th
                                            style={{
                                                textAlign: "right",
                                                padding: "8px",
                                                cursor: "pointer",
                                                userSelect: "none",
                                                alignItems: "center",
                                                gap: 6,
                                            }}
                                            onClick={() => toggleSort("totalunits")}
                                        >
                                            Max Unit
                                            <span style={{ fontSize: 11 }}>{sortKey === "totalunits" ? (sortDir === "asc" ? "▲" : "▼") : "↕"}</span>
                                        </th>
                                        {/* <th title="ESTIMATED POST DEVELOPED VALUE"
                                            style={{
                                                textAlign: "right",
                                                padding: "8px",
                                                cursor: "pointer",
                                                userSelect: "none",
                                                alignItems: "center",
                                                gap: 6,
                                            }}
                                            onClick={() => toggleSort("totallandvalue")}
                                        >
                                            20% Dev. value
                                            <span style={{ fontSize: 11 }}>{sortKey === "totallandvalue" ? (sortDir === "asc" ? "▲" : "▼") : "↕"}</span>
                                        </th> */}

                                        <th
                                            title="ESTIMATED POST DEVELOPED VALUE"
                                            style={{
                                                textAlign: "right",
                                                padding: "8px",
                                                cursor: "pointer",
                                                userSelect: "none",
                                            }}
                                            onClick={() => toggleSort("totallandvalue")}
                                        >
                                            <div
                                                style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "flex-end",
                                                    gap: 6,
                                                    minWidth: 0, // for ellipsis in flex
                                                }}
                                            >
                                                <span
                                                    style={{
                                                        overflow: "hidden",
                                                        textOverflow: "ellipsis",
                                                        whiteSpace: "nowrap",
                                                        minWidth: 0,
                                                        flex: 1, // Text takes remaining space
                                                    }}
                                                >
                                                    20% Dev. value
                                                </span>

                                                <span
                                                    style={{
                                                        fontSize: 11,
                                                        flexShrink: 0, // ICON NEVER SHRINKS
                                                    }}
                                                >
                                                    {sortKey === "totallandvalue"
                                                        ? sortDir === "asc"
                                                            ? "▲"
                                                            : "▼"
                                                        : "↕"}
                                                </span>
                                            </div>
                                        </th>

                                        {/* <th title="SALES PRICE" style={{ textAlign: "right", padding: "8px" }}>Price</th> */}
                                        <th
                                            title="SALES PRICE"
                                            style={{
                                                textAlign: "right",
                                                padding: "8px",
                                                cursor: "pointer",
                                                userSelect: "none",
                                            }}
                                            onClick={() => toggleSort("zestimate")}
                                        >
                                            Price
                                            <span style={{ fontSize: 11 }}>
                                                {sortKey === "zestimate" ? (sortDir === "asc" ? "▲" : "▼") : "↕"}
                                            </span>
                                        </th>

                                        <th style={{ textAlign: "right", padding: "8px" }}>Spread</th>
                                        {/* <th style={{ textAlign: "right", padding: "8px" }}>Spread %</th> */}
                                        <th
                                            style={{
                                                textAlign: "right",
                                                padding: "8px",
                                                cursor: "pointer",
                                                userSelect: "none",
                                                alignItems: "center",
                                                gap: 6,
                                            }}
                                            onClick={() => toggleSort("spreadpercentage")}
                                        >
                                            Spread(%)
                                            <span style={{ fontSize: 11 }}>
                                                {sortKey === "spreadpercentage" ? (sortDir === "asc" ? "▲" : "▼") : "↕"}
                                            </span>
                                        </th>
                                        {/* <th style={{ textAlign: "left", padding: "8px" }}>zonedcodelocal</th> */}

                                        {/* <th style={{ textAlign: "left", padding: "8px", maxWidth: "140px" }}>Listed Sale</th> */}
                                    </tr>
                                </thead>

                                <tbody>
                                    {sortedParcels.map((item, i) => {
                                        const p = item || {};
                                        // const parcelId = p.parcel || p.parcelid || p.geo_id || p.id || `row-${i}`;
                                        // const isSelected = selectedParcelId === parcelId;


                                        // compute adjacent id from property
                                        const parcel = p.parcel || p.parcelid || p.geo_id || p.id || "";
                                        const adjacent = p.touching_parcel || p.adjacent_parcel || null;
                                        const isFavorite = favoriteParcelIds.some((fav) => normalizeParcelIdentifier(fav) === normalizeParcelIdentifier(parcel));

                                        // Match the composite key logic from NCComponent.handleRowClick
                                        const rowKey = isAdjacentMode ? `${parcel}-${adjacent || ''}` : parcel;
                                        const isClickedRow = String(rowKey) === String(selectedParcelId);
                                        const isSelectedRow = selectedRowIds && selectedRowIds.has(rowKey);

                                        return (
                                            <tr
                                                key={rowKey + i}
                                                //   onClick={() => handleRowClick(p, i)}
                                                onClick={(e) => {
                                                    // Prevent handleRowClick if clicking on checkbox
                                                    if (e.target.type === "checkbox" || e.target.closest("input[type='checkbox']")) {
                                                        return;
                                                    }
                                                    handleRowClick(p, i);
                                                }}
                                                style={{
                                                    background: isSelectedRow
                                                        ? "#d4f1e8"
                                                        : isClickedRow
                                                            // ? "#dcedeb"
                                                            ? "#fff3bae0"
                                                            : i % 2 === 0
                                                                ? "#fff"
                                                                : "#f9f9f9",
                                                    borderBottom: "1px solid #f0f0f0",
                                                    cursor: "pointer",
                                                    transition: "background 0.2s ease",
                                                }}
                                                onMouseEnter={(e) => {
                                                    if (!isSelectedRow && !isClickedRow) {
                                                        e.currentTarget.style.background = "#f5f5f5";
                                                    }
                                                }}
                                                onMouseLeave={(e) => {
                                                    if (!isSelectedRow && !isClickedRow) {
                                                        e.currentTarget.style.background =
                                                            i % 2 === 0 ? "#fff" : "#f9f9f9";
                                                    }
                                                }}
                                            >

                                                <td style={{ textAlign: "center", padding: "8px", fontWeight: "500", color: "#666" }}>
                                                    {/* {selectionMode && !isAdjacentMode ? ( */}
   {showFavoritesOnly && !isAdjacentMode  ?(

                                                        <input
                                                            type="checkbox"
                                                            checked={isSelectedRow}
                                                            onChange={(e) => {
                                                                e.stopPropagation();
                                                                if (typeof toggleRowSelection === "function") {
                                                                    toggleRowSelection(p);
                                                                }
                                                            }}
                                                            style={{ cursor: "pointer" }}
                                                        />
                                                    ) : (
                                                        rowOffset + i + 1
                                                    )}
                                                </td>
                                                {/* {!isAdjacentMode && (
                                                    <td style={{ textAlign: "center", padding: "8px", width: "50px" }}>
                                                        <button
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                if (typeof onToggleFavorite === "function") {
                                                                    onToggleFavorite(p);
                                                                }
                                                            }}
                                                            style={{
                                                                border: "none",
                                                                background: "transparent",
                                                                cursor: "pointer",
                                                                padding: "0",
                                                                display: "inline-flex",
                                                                alignItems: "center",
                                                                justifyContent: "center",
                                                            }}
                                                            title={isFavorite ? "Remove favorite" : "Add favorite"}
                                                        >
                                                            <img
                                                                src={isFavorite ? "/assets/favorite-G.svg" : "/assets/not_favorite.svg"}
                                                                alt={isFavorite ? "Favorite" : "Not Favorite"}
                                                                style={{ width: "18px", height: "18px", display: "block" }}
                                                            />
                                                        </button>
                                                    </td>
                                                )} */}

{!isAdjacentMode && (
                                                <td
    style={{
        textAlign: "center",
        padding: "8px",
        width: "50px",
    }}
>
         {!showFavoritesOnly ? (
            <>
    {isSelectMode ? (
        <input
            type="checkbox"
            checked={isSelectedRow}
            onChange={(e) => {
                e.stopPropagation();

                if (typeof toggleRowSelection === "function") {
                    toggleRowSelection(p);
                }
            }}
            style={{ cursor: "pointer" }}
        />
    ) : (
        <button
            onClick={(e) => {
                e.stopPropagation();

                if (typeof onToggleFavorite === "function") {
                    onToggleFavorite(p);
                }
            }}
            style={{
                border: "none",
                background: "transparent",
                cursor: "pointer",
                padding: "0",
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
            }}
            title={isFavorite ? "Remove favorite" : "Add favorite"}
        >
            <img
                src={
                    isFavorite
                        ? "/assets/favorite-G.svg"
                        : "/assets/not_favorite.svg"
                }
                alt={isFavorite ? "Favorite" : "Not Favorite"}
                style={{
                    width: "18px",
                    height: "18px",
                    display: "block",
                }}
            />
        </button>
    )}

           </>
        ):(  <button
            onClick={(e) => {
                e.stopPropagation();

                if (typeof onToggleFavorite === "function") {
                    onToggleFavorite(p);
                }
            }}
            style={{
                border: "none",
                background: "transparent",
                cursor: "pointer",
                padding: "0",
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
            }}
            title={isFavorite ? "Remove favorite" : "Add favorite"}
        >
            <img
                src={
                    isFavorite
                        ? "/assets/favorite-G.svg"
                        : "/assets/not_favorite.svg"
                }
                alt={isFavorite ? "Favorite" : "Not Favorite"}
                style={{
                    width: "18px",
                    height: "18px",
                    display: "block",
                }}
            />
        </button>)}
</td>
)}
                                                <td style={{ padding: "8px", ...(isAdjacentMode ? { width: "120px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" } : {}) }}>{
                                                    isAdjacentMode
                                                        ? 
                                                        // [p.parcel || "N/A", (p.touching_parcel || p.adjacent_parcel) || null]
                                                        //     .filter(Boolean)
                                                        //     .join(" - ")
                                                         (<span 
                                                            title={
                                                                [p.parcel || "N/A", (p.touching_parcel || p.adjacent_parcel) || null]
                                                                    .filter(Boolean)
                                                                    .join(" - ")
                                                            }
                                                            style={{
                                                                display: "block",
                                                                overflow: "hidden",
                                                                textOverflow: "ellipsis",
                                                                whiteSpace: "nowrap"
                                                            }}
                                                        >
                                                            {[p.parcel || "N/A", (p.touching_parcel || p.adjacent_parcel) || null]
                                                                .filter(Boolean)
                                                                .join(" - ")}
                                                        </span>
                                                    ) 
                                                        : (p.parcel || "N/A")
                                                }</td>
                                                <td style={{ textAlign: "center", padding: "8px" }}>{p.municipality || "N/A"}</td>
                                                <td style={{ textAlign: "right", padding: "8px" }}>
                                                    {p.parcelsize ? parseFloat(p.parcelsize).toFixed(2) : "N/A"}
                                                </td>
                                                <td style={{ textAlign: "right", padding: "8px" }}>{p.zonedcodelocal || "N/A"}</td>

                                                {/* <td style={{ textAlign: "right", padding: "8px" }}>
                                                {p.sqftrate ? `${p.sqftrate.toLocaleString()}` : "N/A"}
                                            </td> */}
                                                <td style={{ textAlign: "right", padding: "8px" }}>

                                                    {p.targetarv ? `$${parseFloat(p.targetarv).toLocaleString('en-US')}` : "N/A"}
                                                </td>
                                                <td style={{ textAlign: "right", padding: "8px" }}>
                                                    {p.landvalueperunit ? `$${parseFloat(p.landvalueperunit).toLocaleString('en-US')}` : "N/A"}

                                                </td>

                                                {isAdjacentMode && (
                                                    <td
                                                        style={{ textAlign: "right", padding: "8px" }}
                                                    >
                                                        20 +
                                                    </td>
                                                )}

                                                <td style={{ textAlign: "right", padding: "8px" }}>
                                                    {p.totalunits ? `${p.totalunits.toLocaleString()}` : "N/A"}
                                                </td>
                                                <td style={{ textAlign: "right", padding: "8px" }}>

                                                    {p.totallandvalue ? `$${parseFloat(p.totallandvalue).toLocaleString('en-US')}` : "N/A"}

                                                </td>
                                                <td style={{ textAlign: "right", padding: "8px" }}>
                                                    {p.zestimate ? `$${parseFloat(p.zestimate).toLocaleString('en-US')}` : "N/A"}
                                                </td>
                                                <td style={{ textAlign: "right", padding: "8px" }}>
                                                    {p.spread != null
                                                        ? p.spread < 0
                                                            ? `-$${Math.abs(p.spread).toLocaleString("en-US")}`
                                                            : `$${p.spread.toLocaleString("en-US")}`
                                                        : "N/A"}
                                                </td>
                                                <td style={{ textAlign: "right", padding: "8px" }}>
                                                    {p.spreadpercentage != null
                                                        ? p.spreadpercentage < 0
                                                            ? `-${Math.abs(p.spreadpercentage).toLocaleString("en-US")}`
                                                            : `${p.spreadpercentage.toLocaleString("en-US")}`
                                                        : "N/A"}
                                                </td>
                                                {/* <td style={{ textAlign: "left", padding: "8px" }}>
                                                {p.zonedcodelocal ? `${p.zonedcodelocal.toLocaleString()}` : "N/A"}
                                            </td> */}
                                            </tr>
                                        );
                                    })}


                                </tbody>
                            </table>

                            {showDeletePopup && (
    <div
        style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0,0,0,0.4)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
        }}
    >
        <div
            style={{
                width: "380px",
                background: "#fff",
                borderRadius: "14px",
                padding: "24px",
                boxShadow: "0 8px 24px rgba(0,0,0,0.2)",
                position: "relative",
            }}
        >
            {/* Close Button */}
            <button
                onClick={closeDeletePopup}
                style={{
                    position: "absolute",
                    top: "12px",
                    right: "12px",
                    border: "none",
                    background: "transparent",
                    fontSize: "20px",
                    cursor: "pointer",
                    color: "#666",
                }}
            >
                ×
            </button>

            {/* Title */}
            <h3
                style={{
                    margin: 0,
                    marginBottom: "12px",
                    fontSize: "20px",
                    fontWeight: "600",
                    color: "#222",
                }}
            >
                Confirm Removal
            </h3>

            {/* Message */}
            <p
                style={{
                    margin: 0,
                    marginBottom: "24px",
                    color: "#555",
                    fontSize: "15px",
                    lineHeight: "1.5",
                }}
            >
            Remove selected favorites?
            </p>

            {/* Actions */}
            <div
                style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    gap: "12px",
                }}
            >
                {/* No Button */}
                <button
                    onClick={closeDeletePopup}
                    style={{
                        padding: "10px 18px",
                        borderRadius: "8px",
                        border: "1px solid #ccc",
                        background: "#fff",
                        cursor: "pointer",
                        fontWeight: "500",
                    }}
                >
                    No
                </button>

                {/* Yes Button */}
                <button
                    onClick={confirmRemoveFavorites}
                    style={{
                        padding: "10px 18px",
                        borderRadius: "8px",
                        border: "none",
                        background: "#d9534f",
                        color: "#fff",
                        cursor: "pointer",
                        fontWeight: "600",
                    }}
                >
                    Yes
                </button>
            </div>
        </div>
    </div>
)}

                            {/* Scroll target for infinite scroll */}
                            <div ref={loadMoreTargetRef} style={{ height: '20px' }}></div>

                            {/* Loading indicator when fetching more */}
                            {isLoadingMore && (
                                <div style={{
                                    padding: "20px",
                                    textAlign: "center",
                                    borderTop: "1px solid #e0e0e0",
                                    backgroundColor: "#f9f9f9"
                                }}>
                                    <div style={{
                                        display: "inline-block",
                                        width: "20px",
                                        height: "20px",
                                        border: "3px solid #f3f3f3",
                                        borderTop: "3px solid #1c8f7d",
                                        borderRadius: "50%",
                                        animation: "spin 1s linear infinite"
                                    }}></div>
                                    <style>{`
                                        @keyframes spin {
                                            0% { transform: rotate(0deg); }
                                            100% { transform: rotate(360deg); }
                                        }
                                    `}</style>
                                    <p style={{ marginTop: "10px", color: "#666", fontSize: "14px" }}>
                                        Loading more parcels...
                                    </p>
                                </div>
                            )}

                            {/* End of list indicator */}
                            {!hasMore && parcels.length > 0 && (
                                <div style={{
                                    padding: "20px",
                                    textAlign: "center",
                                    borderTop: "1px solid #e0e0e0",
                                    color: "#999",
                                    fontSize: "14px"
                                }}>
                                    All records loaded ({parcels.length} total)
                                </div>
                            )}

                            {/* Fixed position action button - bottom left */}
                            {/* {selectionMode && !isAdjacentMode && selectedRowIds && selectedRowIds.size > 0 && ( */}
                            { !isAdjacentMode && selectedRowIds && selectedRowIds.size > 0 && (
                                <div style={{
                                    position: "fixed",
                                    bottom: "30px",
                                    left: "50px",
                                    zIndex: 9999,
                                    display: "flex",
                                    gap: "10px",
                                }}>
                                    {!showFavoritesOnly ? (
                                        <button
                                            onClick={onSaveToFavorites}
                                            style={{
                                                padding: "12px 24px",
                                                backgroundColor: "#1c8f7d",
                                                color: "white",
                                                border: "none",
                                                borderRadius: "8px",
                                                fontSize: "15px",
                                                fontWeight: "600",
                                                cursor: "pointer",
                                                transition: "all 0.3s",
                                                boxShadow: "0 4px 12px rgba(28, 143, 125, 0.3)",
                                                display: "flex",
                                                alignItems: "center",
                                                gap: "8px",
                                            }}
                                            onMouseEnter={(e) => {
                                                e.target.style.backgroundColor = "#157a6d";
                                                e.target.style.transform = "translateY(-2px)";
                                                e.target.style.boxShadow = "0 6px 16px rgba(28, 143, 125, 0.4)";
                                            }}
                                            onMouseLeave={(e) => {
                                                e.target.style.backgroundColor = "#1c8f7d";
                                                e.target.style.transform = "translateY(0)";
                                                e.target.style.boxShadow = "0 4px 12px rgba(28, 143, 125, 0.3)";
                                            }}
                                        >
                                            {/* Save to Favorites ({selectedRowIds.size}) */}
                                            Add to Favorites ({selectedRowIds.size})
                                        </button>
                                    ) : (
                                        <>
                                        <button
                                            onClick={onExportCsv}
                                            style={{
                                                padding: "12px 24px",
                                                backgroundColor: "#1c8f7d",
                                                color: "white",
                                                border: "none",
                                                borderRadius: "8px",
                                                fontSize: "15px",
                                                fontWeight: "600",
                                                cursor: "pointer",
                                                transition: "all 0.3s",
                                                boxShadow: "0 4px 12px rgba(28, 143, 125, 0.3)",
                                                display: "flex",
                                                alignItems: "center",
                                                gap: "8px",
                                            }}
                                            onMouseEnter={(e) => {
                                                e.target.style.backgroundColor = "#157a6d";
                                                e.target.style.transform = "translateY(-2px)";
                                                e.target.style.boxShadow = "0 6px 16px rgba(28, 143, 125, 0.4)";
                                            }}
                                            onMouseLeave={(e) => {
                                                e.target.style.backgroundColor = "#1c8f7d";
                                                e.target.style.transform = "translateY(0)";
                                                e.target.style.boxShadow = "0 4px 12px rgba(28, 143, 125, 0.3)";
                                            }}
                                        >
                                            {/* Export Favorites ({selectedRowIds.size}) */}
                                            Export ({selectedRowIds.size})
                                            {/* Export Favorites */}
                                        </button>
                                        <button
                                            // onClick={onRemoveFromFavorites}
                                             onClick={handleRemoveFavorites}
                                            style={{
                                                padding: "12px 24px",
                                                backgroundColor: "#d9534f",
                                                color: "white",
                                                border: "none",
                                                borderRadius: "8px",
                                                fontSize: "15px",
                                                fontWeight: "600",
                                                cursor: "pointer",
                                                transition: "all 0.3s",
                                                boxShadow: "0 4px 12px rgba(217, 83, 79, 0.3)",
                                                display: "flex",
                                                alignItems: "center",
                                                gap: "8px",
                                            }}
                                            onMouseEnter={(e) => {
                                                e.target.style.backgroundColor = "#c9302c";
                                                e.target.style.transform = "translateY(-2px)";
                                                e.target.style.boxShadow = "0 6px 16px rgba(217, 83, 79, 0.4)";
                                            }}
                                            onMouseLeave={(e) => {
                                                e.target.style.backgroundColor = "#d9534f";
                                                e.target.style.transform = "translateY(0)";
                                                e.target.style.boxShadow = "0 4px 12px rgba(217, 83, 79, 0.3)";
                                            }}
                                        >
                                            {/* Delete Selected ({selectedRowIds.size}) */}
                                            Remove ({selectedRowIds.size})
                                            {/* Delete Selected */}
                                        </button>
{/* 
                                        <button
                                            // onClick={removeAllFavorites}
                                            onClick={handleRemoveAllFavorites}
                                            style={{
                                                padding: "12px 24px",
                                                backgroundColor: "#d9534f",
                                                color: "white",
                                                border: "none",
                                                borderRadius: "8px",
                                                fontSize: "15px",
                                                fontWeight: "600",
                                                cursor: "pointer",
                                                transition: "all 0.3s",
                                                boxShadow: "0 4px 12px rgba(217, 83, 79, 0.3)",
                                                display: "flex",
                                                alignItems: "center",
                                                gap: "8px",
                                            }}
                                            onMouseEnter={(e) => {
                                                e.target.style.backgroundColor = "#c9302c";
                                                e.target.style.transform = "translateY(-2px)";
                                                e.target.style.boxShadow = "0 6px 16px rgba(217, 83, 79, 0.4)";
                                            }}
                                            onMouseLeave={(e) => {
                                                e.target.style.backgroundColor = "#d9534f";
                                                e.target.style.transform = "translateY(0)";
                                                e.target.style.boxShadow = "0 4px 12px rgba(217, 83, 79, 0.3)";
                                            }}
                                        >
                                            Clear All
                                        </button> */}

                                        </>
                                    )}
                                </div>
                            )}

                            {/* Downloaded success message */}
                            {showDownloadButton && (
                                <div style={{
                                    padding: "15px 20px",
                                    textAlign: "center",
                                    borderTop: "2px solid #4CAF50",
                                    backgroundColor: "#f1f8f6",
                                    color: "#2e7d32",
                                    fontSize: "14px",
                                    fontWeight: "600",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    gap: "8px",
                                    animation: "slideIn 0.3s ease-in-out"
                                }}>
                                    <span style={{
                                        width: "20px",
                                        height: "20px",
                                        backgroundColor: "#4CAF50",
                                        color: "white",
                                        borderRadius: "50%",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        fontSize: "12px",
                                        fontWeight: "bold"
                                    }}>✓</span>
                                    Downloaded Successfully
                                </div>
                            )}
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};

export default PropertyList;
